import { createSlice } from '@reduxjs/toolkit';
import { addNewColor, editColor, getAllColors } from './colorsService';

const initialState = {
  allColors: {
    isColorsLoading: null,
    isColorsSuccess: null,
    colorsMessage: null,
    pageCount: 0,
    colors: [],
  },
  newColor: {
    isColorCreating: null,
    isColorCreated: null,
    colorCreationMsg: null,
  },

  editedColor: {
    isEditingColor: null,
    isColorEdited: null,
    colorEditedMsg: null
  }
};

const colorsSlice = createSlice({
  name: 'color',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllColors.pending, (state) => {
        state.allColors = {
          ...initialState.allColors, // Reset to initial state
          isColorsLoading: true,
          colorsMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllColors.rejected, (state, action) => {
        state.allColors = {
          ...initialState.allColors,
          isColorsLoading: false,
          isColorsSuccess: false,
          colorsMessage: action.payload || 'Error occurred while fetching colors',
        };
      })

      // FULFILLED
      .addCase(getAllColors.fulfilled, (state, action) => {
        state.allColors = {
          ...initialState.allColors,
          isColorsLoading: false,
          isColorsSuccess: true,
          pageCount: action.payload.pageCount || 0,
          colors: action.payload.data || [],
        };
      });

    //Color creating
    builder
      .addCase(addNewColor.pending, (state) => {
        state.newColor = {
          ...initialState.newColor, // Reset to initial state
          isColorCreating: true,
          colorCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewColor.rejected, (state, action) => {
        state.newColor = {
          ...initialState.newColor,
          isColorCreating: false,
          isColorCreated: false,
          colorCreationMsg: action.payload || 'Error occurred while creating the color.',
        };
      })

      // FULFILLED
      .addCase(addNewColor.fulfilled, (state, action) => {
        state.newColor = {
          ...initialState.newColor,
          isColorCreating: false,
          isColorCreated: true,
          colorCreationMsg: action.payload || 'Successfully created the color.',
        };
      });

    //Color editing
    builder
      .addCase(editColor.pending, (state) => {
        state.editedColor = {
          ...initialState.editedColor, // Reset to initial state
          isEditingColor: true,
          colorEditedMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(editColor.rejected, (state, action) => {
        state.editedColor = {
          ...initialState.editedColor, // Reset to initial state
          isEditingColor: false,
          isColorEdited: false,
          colorEditedMsg: action.payload || 'Error occurred while editing the color.',
        };
      })

      // FULFILLED
      .addCase(editColor.fulfilled, (state, action) => {
        state.editedColor = {
          ...initialState.editedColor, // Reset to initial state
          isEditingColor: false,
          isColorEdited: true,
          colorEditedMsg: action.payload || 'Successfully edited the color.',
        };
      });
  },
});

export default colorsSlice.reducer;
